webpackJsonp([35783957827783],{

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Code = function Code(_ref) {
	    var code = _ref.code;
	    return _react2.default.createElement(
	        'p',
	        { className: 'code' },
	        code
	    );
	};
	
	exports.default = Code;
	module.exports = exports['default'];

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/OS.2935bd96.png";

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _syntax = __webpack_require__(75);
	
	var _syntax2 = _interopRequireDefault(_syntax);
	
	var _OS = __webpack_require__(443);
	
	var _OS2 = _interopRequireDefault(_OS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('img', { alt: 'zubi-logo', className: 'zlogo', src: _OS2.default }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Great job in getting your first Pull Request merged!.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Goto ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/submissions/' },
	        'Submissions '
	      ),
	      'section to view your contribution? ',
	      _react2.default.createElement('i', { className: 'em em-grinning_face_with_star_eyes' })
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-643bc437e5d9d6b6aa3e.js